module.exports = __webpack_public_path__ + "img/login-mob.a0589545.png";